
/*========================================================================
* $Id: url.js 75867 2013-10-15 08:09:57Z michael.biebl $
*
* Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2013
*
* Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
* Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
* Urheber festgelegten Stelle in der Funktion des Computerprogramms
* angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
* Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
* Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
* =========================================================================*/

Mindbreeze.define('utils/url',[], function () {
    
    // returns the origin (protocol + host + port)
    var getOriginFromDataSource = function(dataSource) {
      if (!dataSource) return dataSource;

      var match = dataSource.match(/^(http(?:s)?\:)?(\/\/[^\/]+)/im),
          origin;

      if (!match) {
        throw Error('"' + dataSource + '" is not a valid URL');
      }

      return (match[1] || window.location.protocol) + match[2];
    };

    return {
      isRelative: function (channelUrl) {
        return !/^https?:\/\//.test(channelUrl);
      },

      directory: function (url) {
        return url.replace(/\/[^\/]*$/, "/")
      },

      getOriginFromDataSource: getOriginFromDataSource,

      sameOrigin: function (dataSource1, dataSource2) {
        var origin1 = getOriginFromDataSource(dataSource1),
            origin2 = getOriginFromDataSource(dataSource2);

        return origin1 === origin2;
      }
    };
});
